import { Observable } from "rxjs";
import { AccessTokenResponse, ForgotPasswordRequest, IdentityClient, LoginRequest, ManageClient, RefreshRequest, ResendConfirmationEmailRequest, ResetPasswordRequest, SiteConfiguration, UserInfo } from "../api_identity/api";
import { ExternalProxyServer, MethodCallMessage, MethodCallResponse } from "@ticomix/common";
import { IdentityAuthService } from "./identity-auth.service";
import { inject } from "@angular/core";

export class B29IdentityClientServer extends ExternalProxyServer {
    constructor(messagePort: MessagePort) {
        super(messagePort);

        let identityClient: IdentityClient = inject(IdentityClient);
        let identityAuthService: IdentityAuthService = inject(IdentityAuthService);
        let manageClient: ManageClient = inject(ManageClient);

        this.rpcTargets.set("IdentityClient", identityClient);
        this.rpcTargets.set("IdentityAuthService", identityAuthService);
        this.rpcTargets.set("ManageClient", manageClient);
    }
}